import { filterValueToQuery } from '@/api';
import useAxios from '@/useAxios';
import { tokenName } from '@/useAuth';

const { setAuthorization } = useAxios();

let attemptToDownload = 0;
const maximumDownloadAttempt = 2;

export default function report(axios: any) {
  const getChatAsCSV: any = async (
    userId: number | null,
    liveSessionId: number | null,
  ) => {
    try {
      const response = await axios.get(`/chat/asCsv?${userId !== null ? `filterUserId=${userId}&` : ''}${liveSessionId !== null ? `filterLiveSessionId=${liveSessionId}` : ''}`);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `chat-live-platform${liveSessionId !== null ? `-${liveSessionId}` : ''}${userId !== null ? `-${userId}` : ''}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        attemptToDownload = 0;
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const getVoteAsCSV: any = async (
    userId: number | null,
    pollId: number | null,
    pollChoiceId: number | null,
  ) => {
    try {
      const response = await axios.get(`/polls/asCsv?${userId !== null ? `filterUserId=${userId}&` : ''}${pollId !== null ? `filterPollId=${pollId}&` : ''}${pollChoiceId !== null ? `filterPollChoiceId=${pollChoiceId}` : ''}`);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `poll-live-platform${userId !== null ? `-${userId}` : ''}${pollId !== null ? `-${pollId}` : ''}${pollChoiceId !== null ? `-${pollChoiceId}` : ''}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        attemptToDownload = 0;
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const getQAAsCSV: any = async (
    userId: number | null,
    liveSessionId: number | null,
  ) => {
    try {
      const response = await axios.get(`/questions/asCsv?${userId !== null ? `filterUserId=${userId}&` : ''}${liveSessionId !== null ? `filterLiveSessionId=${liveSessionId}` : ''}`);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `questionAndAnswer-live-platform${liveSessionId !== null ? `-${liveSessionId}` : ''}${userId !== null ? `-${userId}` : ''}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        attemptToDownload = 0;
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const getAllQAAsCSV: any = async (
    liveSessionId: number | null,
  ) => {
    try {
      const response = await axios.get(`/questions/asCsv?${liveSessionId !== null ? `filterLiveSessionId=${liveSessionId}` : ''}`);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `questionAndAnswer-live-platform${liveSessionId !== null ? `-${liveSessionId}` : ''}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        attemptToDownload = 0;
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  const getVisitorAsCSV: any = async (query: any = null) => {
    try {
      const response = await axios.get(`/users/asCsv?${filterValueToQuery(query)}&admin=false`);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'visitor-live-platform.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        attemptToDownload = 0;
        return true;
      }
    } catch (error) {
      return false;
    }
    return false;
  };

  return {
    getChatAsCSV,
    getVoteAsCSV,
    getQAAsCSV,
    getAllQAAsCSV,
    getVisitorAsCSV,
  };
}
